export default __webpack_public_path__ + "static/media/contacto.8512347a.png";